// src/config/permissionsConfig.js

export const PERMISSIONS_CONFIG = {
    'home': { 
        name: 'Página Inicial', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'view-stats', label: 'Ver Estatísticas' },
            { id: 'view-recent-tickets', label: 'Ver Chamados Recentes' }
        ]
    },
    'client-contracts': { 
        name: 'Clientes Contrato', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'add-client', label: 'Adicionar Cliente' },
            { id: 'edit-client', label: 'Editar Cliente' },
            { id: 'delete-client', label: 'Excluir Cliente' },
            { id: 'view-passwords', label: 'Ver Senhas do Cliente' }
        ]
    },
    'client-one-off': { 
        name: 'Clientes Avulsos', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'add-client', label: 'Adicionar Cliente' },
            { id: 'edit-client', label: 'Editar Cliente' },
            { id: 'delete-client', label: 'Excluir Cliente' }
        ]
    },
    'wiki': { 
        name: 'Wiki', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'add-article', label: 'Adicionar Artigo' },
            { id: 'edit-article', label: 'Editar Artigo' },
            { id: 'delete-article', label: 'Excluir Artigo' }
        ]
    },
    'passwords': { 
        name: 'Cofre de Senhas', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'view-password', label: 'Visualizar Senha' },
            { id: 'copy-password', label: 'Copiar Senha' },
            { id: 'add-credential', label: 'Adicionar Credencial' },
            { id: 'edit-credential', label: 'Editar Credencial' },
            { id: 'delete-credential', label: 'Excluir Credencial' }
        ]
    },
    'tickets': { 
        name: 'Chamados', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'open-ticket', label: 'Abrir Chamado' },
            { id: 'delete-ticket', label: 'Excluir Chamado' },
            { id: 'manage-status', label: 'Alterar Status' },
            { id: 'assign-technician', label: 'Atribuir Técnico' },
            { id: 'add-comment', label: 'Adicionar Comentários' },
            { id: 'view-technical-data', label: 'Ver Dados Técnicos' },
            { id: 'edit-technical-data', label: 'Lançar Dados Técnicos' },
            { id: 'manage-settings', label: 'Acesso às Configurações (Engrenagem)' },
            { id: 'edit-ticket', label: 'Editar Cabeçalho do Chamado (Lápis)' },
            { id: 'add-technical-category', label: 'Adicionar Categoria Técnica' },
            { id: 'filter-search', label: 'Filtro: Barra de Pesquisa' },
            { id: 'filter-status', label: 'Filtro: Status' },
            { id: 'filter-priority', label: 'Filtro: Prioridade' },
            { id: 'filter-technician', label: 'Filtro: Técnicos' }
        ]
    },
    'manage-access': { name: 'Gerenciar Acessos', permissionLevels: ['edit'] },

    'manage-ticket-info': { name: 'Gerenciar Informações Chamados', permissionLevels: ['read', 'edit'] },
    'service-values': { name: 'Tabela de Preços', permissionLevels: ['read', 'edit'] },
    'technical-reports': { 
        name: 'Laudos Técnicos', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'create-report', label: 'Criar Novo Laudo' },
            { id: 'edit-report', label: 'Editar Laudo' },
            { id: 'delete-report', label: 'Excluir Laudo' },
            { id: 'print-report', label: 'Imprimir Laudo' },
            { id: 'generate-link', label: 'Gerar Link Público' }
        ]
    },
    'acesso-remoto': { name: 'Acesso Remoto', permissionLevels: ['read', 'edit'] },
    'asset-management': { 
        name: 'Gestão de Ativos', 
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'toggle-aam', label: 'Ativar / Desativar AAM' },
            { id: 'view-report', label: 'Gerar Relatório Geral' },
            { id: 'refresh-devices', label: 'Sincronizar Dispositivos' },
            { id: 'delete-asset', label: 'Excluir Ativo' }
        ]
    },
    'avisos': { 
        name: 'Avisos & Alertas', 
        permissionLevels: ['read', 'edit'],
        uiItems: []
    },
    'financeiro': {
        name: 'Financeiro: Cobranças',
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'faturar', label: 'Faturar / Agrupar / Desfazer faturamento' },
            { id: 'sync-tickets', label: 'Sincronizar Chamados' },
            { id: 'change-stage', label: 'Alterar Etapa (Cobrança Enviada / Recebido)' },
            { id: 'send-charge', label: 'Enviar Cobrança por E-mail' },
            { id: 'cancel-charge', label: 'Cancelar Cobrança' },
            { id: 'edit-details', label: 'Editar Detalhes (vencimento, observações)' }
        ]
    },
    'contracts': {
        name: 'Gestão de Contratos',
        permissionLevels: ['read', 'edit'],
        uiItems: [
            { id: 'create-template', label: 'Criar / Editar Modelos' },
            { id: 'create-contract', label: 'Criar Contrato para Cliente' },
            { id: 'edit-contract', label: 'Editar / Versionar Contrato' },
            { id: 'delete-contract', label: 'Excluir Contrato / Modelo' }
        ]
    }
};

export const ADMIN_EMAIL = 'jonathan@arcusinformatica.com.br';